import { useEffect } from "react";
import { applyBranding } from "../lib/branding";

/**
 * Coloca a logo da empresa como favicon e o nome no título da aba
 * quando os dados de GET /companies/{code} chegam (ver useCompany).
 *
 * @param {Object|null} company - CompanyResponseDTO ({ name, logoUrl, ... })
 */
export const useCompanyBranding = (company) => {
  const name = company?.name;
  const logoUrl = company?.logoUrl;

  useEffect(() => {
    if (!name && !logoUrl) return;
    applyBranding({ name, logoUrl }, { persist: true });
  }, [name, logoUrl]);
};
